export default __webpack_public_path__ + "static/media/VID-20210318-WA0020.2d4fc805.mp4";